
import { Component } from 'react'
import { Link } from 'react-router-dom'
import { RouterProps, withRouter } from '../../../../insfrastructure/utils/with-router-component'
import { listJobs } from '../../../../insfrastructure/services/jobs'
import { retriveJobApply } from '../../../../insfrastructure/services/job-applies'
import { retrieveCandidate } from '../../../../insfrastructure/services/candidates'
import IntervalModal from './interview-modal'
import RepproveModal from './repprove-modal'
import infoIcon from '../../../../assets/icons/info.png'
import profileIcon from '../../../../assets/icons/male-icon.svg'
import houseIcon from '../../../../assets/icons/house.png'
import emailIcon from '../../../../assets/icons/mail.svg'
import phoneIcon from '../../../../assets/icons/phone.png'
import repproveIcon from '../../../../assets/icons/delete-white.png'
import calendarIcon from '../../../../assets/icons/calendar-white.png'
import './styles.sass'
import moment from 'moment'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { listExpirences } from '../../../../insfrastructure/services/experiences'
import { listCourses } from '../../../../insfrastructure/services/courses'
import { generateKey } from '../../../../insfrastructure/utils/array-key'

class Candidate extends Component<RouterProps> {
    state: any = {
        offer: {
            jobTitle: {
                name: ''
            }
        },
        jobapply: {
            status: ''
        },
        course_progress: {},
        marital_status: {},
        skills_options: [],
        skills: [],
        experiences: [],
        scholarships: [],
        candidate: {},
        em_units: [],
        em_courses: {},
        updateCandidateLoading: false,
        renderCallForInterviewModal: false,
        renderRepproveCandidateModal: false
    }

    async componentDidMount() {
        await this.getStaticValues();
        await this.retriveJob();
        await this.retriveCandidate();
        setTimeout(async () => {
            await this.listSkills();
            await this.listExpirences();
            await this.listCourses();   
        }, 1000);
    }

    getStaticValues = async () => {
        try {  
            setTimeout(() => {
                const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
                const marital_status = staticValues.marital_status;
                const skills_options = staticValues.skills;
                const course_progress = staticValues.course_progress;
                const em_units = staticValues.em_unit;
                const em_courses = staticValues.em_course;
                
                this.setState({ marital_status, skills_options, course_progress, em_units, em_courses }); 
            }, 1000);
        } catch (error) {}
    }

    retriveJob = async () => {
        try {
          const offer = (await listJobs({ id: this.props.params?.offer_id })).data[0];
          this.setState({ offer });
        } catch (error) {}
    }

    retriveCandidate = async () => {
        try {
          const jobapply = await retriveJobApply(this.props.params?.jobapply_id );
          const candidate = await retrieveCandidate(jobapply.candidate_id );

          console.log(jobapply, candidate);
          
          this.setState({ jobapply, candidate });
        } catch (error) {}
    }

    listSkills = async () => {
        const skills = this.state.skills_options.filter((x: any) => 
            this.state.candidate.skills.includes(x.id)
        );

        console.log(this.state.skills_options, this.state.candidate.skills, skills);

        this.setState({ skills });
    }

    listExpirences = async () => {
        try {
            const experiences = await listExpirences(this.state.jobapply.candidate_id);

            console.log(experiences.results);

            this.setState({ experiences: experiences.results });
        } catch (error) {
            console.log(error);
            
        }
    }

    listCourses = async () => {
        try {
            const courses = await listCourses(this.state.jobapply.candidate_id);

            console.log(courses.results);

            console.log(this.state.em_units);
            

            const formatted_courses = courses.results.map((x) => {
                x.em_unit = x.em_unit ? this.state.em_units.filter((y: any) => y.id === x.em_unit)[0].name : x.em_unit;
                x.em_course = x.em_course ? this.state.em_courses[x.em_course] : x.em_course;

                console.log(x);
                

                return x;
            });

            this.setState({ scholarships: formatted_courses });
        } catch (error) {
            console.log(error);
            
        }
    }

    getCandidateAge = (date_of_birth_string: string) => {
        var current_date = moment();
        var date_of_birth = moment(date_of_birth_string);
        var years = current_date.diff(date_of_birth, 'years');
        
        return years;
    }

    toggleCallForInterviewModal = () => {
        this.setState({ renderCallForInterviewModal: !this.state.renderCallForInterviewModal });
    }

    toggleRepproveCandidateModal = () => {
        this.setState({ renderRepproveCandidateModal: !this.state.renderRepproveCandidateModal });
    }
    onCandidateRepproved = async () => {
        this.toggleRepproveCandidateModal();
    }

    onCandidateCalledForInterview = async () => {
        this.toggleCallForInterviewModal();
        this.retriveCandidate();
    }

    getExperiencePeriod = (start_date_string: string, end_date_string: string) => {
        let result = '';

        let current_date = moment();
        let start_date = moment(start_date_string);
        let end_date = moment(end_date_string);
        
        if (!end_date_string || current_date.isBefore(end_date)) {
            const years_in_the_job = current_date.diff(start_date, 'years');

            result = `Atualmente` + (years_in_the_job > 0 ? `(${years_in_the_job} anos)` : '');
        } else {
          result = end_date.format('MM/YYYY')+'';  
        }

        return start_date.format('MM/YYYY') + ' - ' + result;
    }

    render() {
        return (
            <div className='candidate company-page'>
                <div className='block'>
                    <div className='block-header'>
                        <div className='title'>
                            <img src={infoIcon} alt='info-icon' />
                            <h3><Link to={'/offers'}>Vagas {'>'}</Link> <Link to={'/offers/'+this.props.params?.offer_id+'/candidates'}>{this.state.offer?.jobTitle?.name} - Candidatos {'>'}</Link> Candidato</h3>
                        </div>
                        <div className='actions'>
                            {this.state.jobapply.status === 'applied' &&
                            <button className='not-apt-btn' onClick={this.toggleRepproveCandidateModal}>
                                <img src={repproveIcon} alt='repprove-icon' />
                                <span>Não apto</span>
                            </button>}
                            {
                            this.state.jobapply.status === 'applied' &&    
                            <button className='interview-btn' onClick={this.toggleCallForInterviewModal}>
                                <img src={calendarIcon} alt='calendar-icon' />
                                <span>Chamar para entrevista</span>
                            </button>}
                        </div>
                    </div>
                    <div className='info'>
                        <div className='columns'>
                            <div className='column'>
                                <div className='main section'>
                                    <div className='profile-picture-container'>
                                        <img className='profile-picture' alt='profile-picture' src={profileIcon} />
                                    </div>
                                    <h3>{this.state.candidate.full_name}</h3>
                                    {
                                    Object.keys(this.state.marital_status).length > 0 &&
                                    <div>
                                        <p>
                                            {this.state.marital_status[this.state.candidate.marital_status]}
                                            {this.state.candidate.date_of_birth && ', ' + this.getCandidateAge(this.state.candidate.date_of_birth) + ' anos'}
                                        </p>
                                        <p>{this.state.candidate.city_name}, {this.state.candidate.city_uf}</p>
                                    </div>
                                    }
                                </div>
                                <div className='knowledges section'>
                                    <h3>Habilidades:</h3>
                                    <div className='list'>
                                        {
                                            this.state.skills.map((skill: any, index: number) =>
                                            <span key={generateKey('knowledge_'+index)} className='knowledge'>{skill.name}</span>)                                        }
                                    </div>
                                </div>
                                {/* <div className='abilities section'>
                                    <h3>Conhecimentos:</h3>
                                    <div className='list'>
                                        <span className='ability'>Estudioso</span>
                                    </div>
                                </div> */}
                            </div>
                            <div className='column'>
                                <div className='experiences section'>
                                    <h3>Minhas experiências</h3>
                                    <div className='list'>
                                        {
                                            this.state.experiences.map((experience: any, index: number) =>
                                            <div key={generateKey('experience_'+index)} className='experience'>
                                                <b>{experience.position}</b>
                                                <p>{experience.company_name}</p>
                                                <p>{this.getExperiencePeriod(experience.start_date, experience.end_date)}</p>
                                            </div>)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='column'>
                                <div className='courses section'>
                                    <h3>Meus cursos</h3>
                                    <div className='list'>
                                        {
                                            this.state.scholarships.map((course: any, index: number) =>
                                            <div key={generateKey('course_'+index)} className='course'>
                                                <b>{course.em_course ? course.em_course : course.course_name}</b>
                                                <p>{course.em_unit ? course.em_unit : course.institution}</p>
                                                {/* <p>Campinas, SP</p> */}
                                                <span className={'status '+course.status}>{this.state.course_progress[course.status]}</span>
                                            </div>)
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='basic-info columns section'>
                            <div className='column'>
                                <div className='basic-info-intro'>
                                    <h3>Dados básicos:</h3>
                                    <div className='info-line'>
                                        <img src={phoneIcon} alt='phone-icon' />
                                        <span>{this.state.candidate.mobile}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='column'>
                                <div className='info-line'>
                                    <img src={emailIcon} alt='email-icon' />
                                    <span>{this.state.candidate.email}</span>
                                </div>
                            </div>
                            <div className='column'>
                                <div className='info-line'>
                                    <img src={houseIcon} alt='house-icon' />
                                    <span>
                                        {`${this.state.candidate.address}, 
                                        ${this.state.candidate.address_number ?
                                        this.state.candidate.address_number + ', ' : ''} 
                                        ${this.state.candidate.city_name}, 
                                        ${this.state.candidate.city_uf}
                                        ${this.state.candidate.postcode ?
                                        ' -'+ this.state.candidate.postcode : ''}`}
                                    </span>
                                    {/* <span>Rua Madeleine Peixoto, 340, Belo Horizonte, MG - 30280-180</span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <IntervalModal
                render={this.state.renderCallForInterviewModal}
                candidate={this.state.candidate}
                jobapply_id={this.props.params?.jobapply_id}
                onClose={this.toggleCallForInterviewModal}
                onSubmitted={this.onCandidateCalledForInterview} />
                <RepproveModal
                status='not_fit'
                render={this.state.renderRepproveCandidateModal}
                candidate={this.state.candidate}
                jobapply_id={this.props.params?.jobapply_id}
                onClose={this.toggleRepproveCandidateModal}
                onSubmitted={this.onCandidateRepproved} />
            </div>
        )
    }
}

export default withRouter(Candidate)
